import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-score-donut',
  templateUrl: './score-donut.component.html',
  styleUrls: ['./score-donut.component.css']
})
export class ScoreDonutComponent implements OnInit,AfterViewInit {

  chart:any;
  @Input() donutid:any;
  @Input() size:any;
  @Input() config:any;
  @Input() gameTranscationMetadata:any;
  outOfScore: number;
  currentScore: number;
  currentScoreAchieved: number;
  backgroundColor = [];
  data = [];
  constructor() { }
  ngAfterViewInit(): void {
    if (this.donutid == 'left') {
      this.data.push(Number(this.gameTranscationMetadata.total_score));
      this.data.push(Number(this.gameTranscationMetadata.total_max_score) - Number(this.gameTranscationMetadata.total_score));
      this.backgroundColor.push('#0072bc')
      this.backgroundColor.push('white')
    }
    if (this.donutid == 'right') {
      this.data.push(Number(this.gameTranscationMetadata.score));
      this.data.push(100 - this.gameTranscationMetadata.score);
      this.backgroundColor.push('#3ab44a')
      this.backgroundColor.push('white')
    }
    this.chart = new Chart(this.donutid, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.data,
            backgroundColor: this.backgroundColor,
            fill: false,
            borderWidth: 0,
          },
        ],
      },
      options: {
        cutoutPercentage: 70,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      },
    });
  }

  ngOnInit() {
    console.log("this.gameTransactionMetaData",this.gameTranscationMetadata);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/Screens/score-donut/score-donut.component.ts